import React, { useState } from 'react';
import { useNavigate } from "react-router-dom"
import {
  Banner,
  BannerBrandSuite,
  BannerBrandLogo,
  BannerBrandInline,
  BannerRight,
  ButtonGroup,
  BannerActionBarItem,
  ButtonField,
  Iconsvg,
  DropdownMoreButton,
  Dropdown,
  DropdownList,
  DropdownListItem,
} from "@wk/components-react16"

import { Auth, logUserActivity, UserActivity } from "../../services"
import ExportActivityLog from '../export-activity-log/ExportActivityLog';

function Header() {
  const user = Auth.getUserame();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const handleLogout = async () => {
    Auth.logout()
    navigate("/");
    let userActivity: UserActivity = {
      action: 'click',
      page: 'Login',
      viewName: 'Banner ActionBar Dropdown More Button Item',
      entityName: 'Logout'
    }
    logUserActivity(userActivity);
  }

  const handlePassword = async () => {
    navigate("/change-password")
    let userActivity: UserActivity = {
      action: 'Click',
      page: 'Change Password',
      viewName: 'Banner ActionBar Dropdown More Button Item',
      entityName: 'Change Password'
    }
    logUserActivity(userActivity);
  }

  const handleActivityLog = async () => {
    setIsOpen(true);
  }

  return (
    <div className="cg-story">
      <Banner isSticky={true}>
        <BannerBrandSuite
          href="#"
          isPreventDefault
          srLabel="Go to Wolters Kluwer Product X home page"
          slot="bannerBrandSuite"
        >
          <BannerBrandLogo slot="bannerBrandLogo"></BannerBrandLogo>
          <BannerBrandInline
            productName="SoS Intel"
            slot="bannerBrand"
          ></BannerBrandInline>
        </BannerBrandSuite>
        <BannerRight slot="bannerRight">
          <ButtonGroup dropdownToggleMode="gray">
            <BannerActionBarItem slot="buttonGroupItem">
              <ButtonField mode={"text"} iconPosition={"left"}>
                <Iconsvg name="user"></Iconsvg>
                {user}
              </ButtonField>
              <DropdownMoreButton
                mode="blue"
                buttonId="button2"
              ></DropdownMoreButton>
              <Dropdown
                targetSelector="#button2"
                menuMode="application"
                srLabelledby="button2"
              >
                <DropdownList menuMode="application">
                  <DropdownListItem
                    slot="dropdownListItem"
                    onItemClick={handleActivityLog}
                  >
                    <Iconsvg name="export"></Iconsvg>
                    Export activity log
                  </DropdownListItem>
                  <DropdownListItem
                    slot="dropdownListItem"
                    onItemClick={handlePassword}
                  >
                    <Iconsvg name="key"></Iconsvg>
                    Change Password
                  </DropdownListItem>
                  <DropdownListItem
                    slot="dropdownListItem"
                    onItemClick={handleLogout}
                  >
                    <Iconsvg name="logout"></Iconsvg>
                    Logout
                  </DropdownListItem>
                </DropdownList>
              </Dropdown>
            </BannerActionBarItem>
          </ButtonGroup>
        </BannerRight>
      </Banner>
      {isOpen && <ExportActivityLog isOpen={isOpen} setIsOpen={setIsOpen} />}
    </div>
  )
}
export default Header
